// "Go to" command palette over the navigation the user is allowed to see.
// (Record search across modules arrives with the reporting/search phase and will query the server.)
import { html, render } from '../utilities/html.js';
import { icon } from '../utilities/icons.js';
import { satisfies } from '../permissions/permissions.js';

export function wireCommandSearch({ trigger, items, getPermissions, navigate }) {
  function open() {
    const pages = [
      ...items.filter((i) => satisfies(getPermissions(), i.permission)),
      { label: 'My profile', path: '/profile', icon: 'user' },
      { label: 'Security & MFA', path: '/profile/security', icon: 'lock' },
      { label: 'Notifications', path: '/notifications', icon: 'bell' },
    ];
    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop';
    backdrop.style.alignItems = 'start';
    backdrop.style.paddingTop = '12vh';
    render(backdrop, html`<div class="modal" role="dialog" aria-modal="true" aria-label="Go to page" style="width:min(520px,100%)">
      <div style="padding:var(--space-4)"><input class="input" type="search" placeholder="Type to filter pages…" aria-label="Filter pages" aria-controls="cmd-list" autocomplete="off"></div>
      <ul class="command-list" id="cmd-list" role="listbox"></ul>
    </div>`);
    const input = backdrop.querySelector('input');
    const list = backdrop.querySelector('ul');
    let index = 0;
    let filtered = pages;

    const paint = () => {
      render(list, filtered.length
        ? html`${filtered.map((p, i) => html`<li><a class="menu-item" role="option" href="${p.path}" aria-selected="${i === index}">${icon(p.icon)}${p.label}</a></li>`)}`
        : html`<li class="text-sm text-subtle" style="padding:var(--space-3)">No matching pages</li>`);
    };
    const close = () => { backdrop.remove(); document.removeEventListener('keydown', onKey, true); trigger.focus(); };
    const go = (p) => { close(); navigate(p.path); };
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); index = Math.min(filtered.length - 1, index + 1); paint(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); index = Math.max(0, index - 1); paint(); }
      else if (e.key === 'Enter' && filtered[index]) { e.preventDefault(); go(filtered[index]); }
    }
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      filtered = pages.filter((p) => p.label.toLowerCase().includes(q));
      index = 0;
      paint();
    });
    list.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      e.preventDefault();
      go(filtered.find((p) => p.path === a.getAttribute('href')));
    });
    backdrop.addEventListener('mousedown', (e) => { if (e.target === backdrop) close(); });
    document.addEventListener('keydown', onKey, true);
    document.body.appendChild(backdrop);
    paint();
    input.focus();
  }

  trigger.addEventListener('click', open);
  const hotkey = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); open(); }
  };
  document.addEventListener('keydown', hotkey);
  return () => document.removeEventListener('keydown', hotkey);
}
